<div class="grid grid-cols-1 my-10">

    <lib-informacion-diligencia 
    [idDiligencia]="expediente.idDiligencia"
    [expediente]="expediente" >
    </lib-informacion-diligencia>
</div>
